import { css } from 'emotion';

export const carousel = css`
  height: 100%;
  width: 100%;
  display: flex;
  overflow-x: hidden;
`;

export const content = css`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  overflow-x: hidden;
  overflow-y: auto;
`;
